import {Validators} from '@angular/forms';

import {SelectControl} from '../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../app/shared/enums';

export const PurposeOfTradingSelector = 'purposeOfTrading';

export const PurposeOfTradingControl = (): SelectControl => {
    return new SelectControl({
        name: PurposeOfTradingSelector,
        value: null,
        placeholder: 'Purpose of trading',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.Select,
        options: [],
        floatingLabelNever: true
    });
};
